import React from 'react'
import styles from './style.module.scss'

const Loading = () => {

  return (
    <div className="main">
      <div className={styles.cont}>
        <span className={styles.swing}>
          网页加载中
      </span>
      </div>
    </div>
  )
}

export default Loading;